import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { useNavigate } from 'react-router-dom';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import makananImg from '../../assets/menu1.jpg';
import minumanImg from '../../assets/menu1.jpg';
import nasiImg from '../../assets/menu1.jpg';
import mieImg from '../../assets/menu1.jpg';
import bowlImg from '../../assets/menu1.jpg';
import addonImg from '../../assets/menu1.jpg';
import snackImg from '../../assets/menu1.jpg';
import allImg from '../../assets/menu1.jpg';

const menuItems = [
  { label: 'Menu Paket', path: 'paket', image: makananImg },
  { label: 'Menu Special', path: 'special', image: minumanImg },
  { label: 'Menu Porsi', path: 'porsi', image: nasiImg },
  { label: 'Nasi Goreng', path: 'nasi-goreng', image: mieImg },
  { label: 'Mie Goreng', path: 'mie-goreng', image: mieImg },
  { label: 'Kwetiau', path: 'kwetiau', image: mieImg },
  { label: 'Bihun', path: 'bihun', image: mieImg },
  { label: 'Bowl', path: 'sayur', image: bowlImg },
  { label: 'Add On', path: 'addon', image: addonImg },
  { label: 'Snack', path: 'snack', image: snackImg },
  { label: 'All', path: '', image: allImg },
];

const groupItems = (items, itemsPerGroup) => {
  let groups = [];
  for (let i = 0; i < items.length; i += itemsPerGroup) {
    groups.push(items.slice(i, i + itemsPerGroup));
  }
  return groups;
};

const CulinaryCarousel = () => {
  const navigate = useNavigate();
  const [itemsPerSlide, setItemsPerSlide] = useState(5);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const updateItemsPerSlide = () => {
      setItemsPerSlide(window.innerWidth < 768 ? 2 : 5);
    };
    updateItemsPerSlide();
    window.addEventListener('resize', updateItemsPerSlide);
    return () => window.removeEventListener('resize', updateItemsPerSlide);
  }, []);

  const remainder = menuItems.length % itemsPerSlide;
  const paddedItems = [...menuItems];
  if (remainder !== 0) {
    const missing = itemsPerSlide - remainder;
    paddedItems.push(...menuItems.slice(0, missing));
  }

  const groupedItems = groupItems(paddedItems, itemsPerSlide);

  return (
    <div className="bg-pink-700 py-6 text-center text-white pt-28 md:pt-24">
      <h2 className="text-2xl font-bold mb-6">Explore Our Culinary</h2>

      <div className="max-w-6xl mx-auto px-4 relative pb-12">
        <Carousel
          showArrows
          showThumbs={false}
          showStatus={false}
          showIndicators={false}
          selectedItem={currentSlide}
          onChange={setCurrentSlide}
          infiniteLoop
          autoPlay
          interval={3000}
          stopOnHover={false}
          swipeable
          emulateTouch
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 text-white hover:text-pink-300 text-3xl"
              >
                ‹
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 text-white hover:text-pink-300 text-3xl"
              >
                ›
              </button>
            )
          }
        >
          {groupedItems.map((group, index) => (
            <div
              key={index}
              className={`grid ${
                itemsPerSlide === 2 ? 'grid-cols-2 gap-4' : 'grid-cols-5 gap-6'
              } justify-items-center`}
            >
              {group.map((item, idx) => (
                <div
                  key={idx}
                  className="flex flex-col items-center cursor-pointer"
                  onClick={() => navigate(`/menu/${item.path}`)}
                >
                  <img
                    src={item.image}
                    alt={item.label}
                    className="w-24 h-24 md:w-28 md:h-28 rounded-full object-cover mb-2 border-2 border-white hover:scale-105 transition-transform"
                  />
                  <p className="text-sm md:text-base text-white font-medium mt-1">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          ))}
        </Carousel>

        {/* Custom Dots Indicator */}
        <div className="mt-6 flex justify-center space-x-2">
          {groupedItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                currentSlide === index ? 'bg-white' : 'bg-white/40'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CulinaryCarousel;
